import { type } from '@/utils/type'


export const ROLE_REQUEST = type('ROLE_REQUEST')
export const ROLE_SUCCESS = type('ROLE_SUCCESS')
export const ROLE_ERROR = type('ROLE_ERROR')

export const ROLE_ENSURE_LIST = type('ROLE_ENSURE_LIST')

export const ROLE_SELECT_DETAIL_REQUEST = type('ROLE_SELECT_DETAIL_REQUEST')
export const ROLE_SELECT_DETAIL_SUCCESS = type('ROLE_SELECT_DETAIL_SUCCESS')
export const ROLE_SELECT_DETAIL_ERROR = type('ROLE_SELECT_DETAIL_ERROR')
export const ROLE_SELECT_DETAIL = type('ROLE_SELECT_DETAIL')

export const ROLE_SAVE_REQUEST = type('ROLE_SAVE_REQUEST')
export const ROLE_SAVE_SUCCESS = type('ROLE_SAVE_SUCCESS')
export const ROLE_SAVE_ERROR = type('ROLE_SAVE_ERROR')

export const ROLE_UPDATE_MODIFIED_ADM = type('ROLE_UPDATE_MODIFIED_ADM')
export const ROLE_CANCEL_MODIFIED_ADM = type('ROLE_CANCEL_MODIFIED_ADM')

export const ROLE_UPDATE_FILTER_ADM = type('ROLE_UPDATE_FILTER_ADM')